const groupSolutionsWhoWeWorkWithFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const clientGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`client-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `client-${index}-title`)) {
      break;
    }

    clientGroups.push({ index, fields: groupFields });
  }

  return { introFields, clientGroups };
};

export default groupSolutionsWhoWeWorkWithFields;
